<template>
  <div class="dass-bonus-balances">
    <div class="dass-card-container">
      <div class="dass-card-content">
        <div class="dass-card-icon-label q-mr-md">
          <q-icon name="mdi-gift" size="50px" color="black" class="q-pb-md"/>  
          <h3>{{$t('dass.couponsQuantity')}}</h3>
        </div>
        <h2><b>{{ quantityActive }}</b></h2> 
        <dass-button class="dass-buttons-wallet" :class="this.isSafari ? `dass-button-primary-${this.brandName} button` : 'button'" variant="tertiary" type="button" @click="toGoCoupons()">
           {{ $t('dass.coupons') }}            
        </dass-button> 
      </div>  
    </div>  
  </div>
</template>

<script>

export default {
  name: 'CouponsQuantity',
  props: {
    quantityValid: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      formData: {
      },
    }
  },
  computed: {
    quantityActive() {
      return this.quantityValid
    }
  },
  methods: {
    toGoCoupons() {
      this.$emit('toGoCoupons')
    }
  }
}

</script>

<style lang="scss" scoped>
.dass-bonus-balances { 
  flex: 1;    
  .dass-card-container { 
    display: flex;
    align-items: center;
    min-height: 12rem;  
    border: var(--border-card);  
    border-radius: var(--border-radius-card);
    @media(max-width: 1395px) {
      height: 100%;
    }
  }
  .dass-card-content { 
    display: flex;
    width: 100%;
    flex-direction: row;
    min-height: 138.47px;    
    align-items: center;
    justify-content:  space-around;
    flex-wrap: wrap;
    padding: var(--space);
    gap: var(--space);
    @media(max-width: 700px) {
        flex-direction: column !important;
    }
    .dass-card-icon-label {
      display: flex;
      flex-direction: column;
      align-items: center;      
    }
    h3 {
      margin: 0;
      text-align: center;
    }
    .dass-button-coupons {
      background-color: #34C759; 
      padding: 10px 20px; 
      border-radius: 5px; 
      cursor: pointer; 
      transition: background-color 0.3s ease; 
      box-shadow: 0 0 0 0 rgba(46, 204, 113, 0.5);
      &:hover {
        animation: pulse-text 1.5s infinite;
        color: #fff;
      }     
    }
    @keyframes pulse-text {
      0% {
        box-shadow: 0 0 0 0 rgba(46, 204, 113, 0.5);        
      }
      70% {
        box-shadow: 0 0 0 10px rgba(46, 204, 113, 0);        
      }
      100% {
        box-shadow: 0 0 0 0 rgba(46, 204, 113, 0);        
      }
    }
  }
}

</style>